import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    patologicas: [],
  },

  getters: {
    getPatologicas: (state) => state.patologicas,
  },

  mutations: {
    SET_PATOLOGICAS(state, patologicas) {
      state.patologicas = patologicas;
    },
  },

  actions: {
    async fetchPatologicas({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catPatologicas')
        .then((response) => {
          commit('SET_PATOLOGICAS', response.data.data);
        });
    },
  },
};
